/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClinicInfo,
  EnterTenantPayload,
  ErrorResponse,
  Manager,
  PortalData,
  Tenant,
  TenantMainContext,
  TenantMainContextResponse,
} from '../models';
import {
    ClinicInfoFromJSON,
    ClinicInfoToJSON,
    EnterTenantPayloadFromJSON,
    EnterTenantPayloadToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ManagerFromJSON,
    ManagerToJSON,
    PortalDataFromJSON,
    PortalDataToJSON,
    TenantFromJSON,
    TenantToJSON,
    TenantMainContextFromJSON,
    TenantMainContextToJSON,
    TenantMainContextResponseFromJSON,
    TenantMainContextResponseToJSON,
} from '../models';

export interface CreateTenantRequest {
    tenant: Tenant;
}

export interface CreateTenantClinicRequest {
    id: string;
    clinicInfo: ClinicInfo;
}

export interface EnterTenantRequest {
    id: string;
    role?: EnterTenantRoleEnum;
}

export interface GetPortalDataRequest {
    tenantId?: string;
}

export interface GetTenantMainContextRequest {
    id: string;
}

export interface ListTenantClinicsRequest {
    id: string;
}

export interface UpdateManagerRequest {
    id: string;
    manager?: Manager;
}

export interface UpdateTenantRequest {
    id: string;
    tenant: Tenant;
}

export interface UpdateTenantMainContextRequest {
    id: string;
    tenantMainContext: TenantMainContext;
}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI {

    /**
     * Create a new tenant (Roles: manager)
     */
    async createTenantRaw(requestParameters: CreateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tenant>> {
        if (requestParameters.tenant === null || requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('Tenant','Required parameter requestParameters.tenant was null or undefined when calling createTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantToJSON(requestParameters.tenant),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createTenantRequestOptionsRaw(requestParameters: CreateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenant === null || requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('Tenant','Required parameter requestParameters.tenant was null or undefined when calling createTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: TenantToJSON(requestParameters.tenant),
        };
        return responseConfig
    }

    /**
     * Create a new tenant (Roles: manager)
     */
    async createTenant(requestParameters: CreateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tenant> {
        const response = await this.createTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a clinic for a tenant (Roles: manager)
     */
    async createTenantClinicRaw(requestParameters: CreateTenantClinicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClinicInfo>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createTenantClinic.');
        }

        if (requestParameters.clinicInfo === null || requestParameters.clinicInfo === undefined) {
            throw new runtime.RequiredError('ClinicInfo','Required parameter requestParameters.clinicInfo was null or undefined when calling createTenantClinic.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}/clinics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClinicInfoToJSON(requestParameters.clinicInfo),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClinicInfoFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createTenantClinicRequestOptionsRaw(requestParameters: CreateTenantClinicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createTenantClinic.');
        }

        if (requestParameters.clinicInfo === null || requestParameters.clinicInfo === undefined) {
            throw new runtime.RequiredError('ClinicInfo','Required parameter requestParameters.clinicInfo was null or undefined when calling createTenantClinic.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}/clinics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ClinicInfoToJSON(requestParameters.clinicInfo),
        };
        return responseConfig
    }

    /**
     * Create a clinic for a tenant (Roles: manager)
     */
    async createTenantClinic(requestParameters: CreateTenantClinicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClinicInfo> {
        const response = await this.createTenantClinicRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enter a tenant for debugging (Roles: manager)
     */
    async enterTenantRaw(requestParameters: EnterTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnterTenantPayload>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enterTenant.');
        }

        const queryParameters: any = {};

        if (requestParameters.role !== undefined) {
            queryParameters['role'] = requestParameters.role;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}/enTer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnterTenantPayloadFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    enterTenantRequestOptionsRaw(requestParameters: EnterTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enterTenant.');
        }

        const queryParameters: any = {};

        if (requestParameters.role !== undefined) {
            queryParameters['role'] = requestParameters.role;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}/enTer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Enter a tenant for debugging (Roles: manager)
     */
    async enterTenant(requestParameters: EnterTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnterTenantPayload> {
        const response = await this.enterTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve tenant_id and client role from the request\'s Referer host (Roles: none)
     */
    async getPortalDataRaw(requestParameters: GetPortalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalData>> {
        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenant_id'] = requestParameters.tenantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/portal-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalDataFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getPortalDataRequestOptionsRaw(requestParameters: GetPortalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenant_id'] = requestParameters.tenantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/portal-data`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Resolve tenant_id and client role from the request\'s Referer host (Roles: none)
     */
    async getPortalData(requestParameters: GetPortalDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalData> {
        const response = await this.getPortalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a tenant\'s AI main-context sections + default template (Roles: manager)
     */
    async getTenantMainContextRaw(requestParameters: GetTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantMainContextResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTenantMainContext.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}/main-context`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantMainContextResponseFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getTenantMainContextRequestOptionsRaw(requestParameters: GetTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTenantMainContext.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}/main-context`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get a tenant\'s AI main-context sections + default template (Roles: manager)
     */
    async getTenantMainContext(requestParameters: GetTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantMainContextResponse> {
        const response = await this.getTenantMainContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all managers (Roles: manager)
     */
    async listManagersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Manager>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/managers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ManagerFromJSON));
    }

    /**
        Request Config Getter
     */
    listManagersRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/managers`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * List all managers (Roles: manager)
     */
    async listManagers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Manager>> {
        const response = await this.listManagersRaw(initOverrides);
        return await response.value();
    }

    /**
     * List clinics for a tenant (Roles: manager)
     */
    async listTenantClinicsRaw(requestParameters: ListTenantClinicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClinicInfo>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listTenantClinics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}/clinics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClinicInfoFromJSON));
    }

    /**
        Request Config Getter
     */
    listTenantClinicsRequestOptionsRaw(requestParameters: ListTenantClinicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listTenantClinics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}/clinics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * List clinics for a tenant (Roles: manager)
     */
    async listTenantClinics(requestParameters: ListTenantClinicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClinicInfo>> {
        const response = await this.listTenantClinicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all tenants (Roles: manager)
     */
    async listTenantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Tenant>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantFromJSON));
    }

    /**
        Request Config Getter
     */
    listTenantsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * List all tenants (Roles: manager)
     */
    async listTenants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Tenant>> {
        const response = await this.listTenantsRaw(initOverrides);
        return await response.value();
    }

    /**
     * update manager (Roles: manager)
     */
    async updateManagerRaw(requestParameters: UpdateManagerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manager>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateManager.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/managers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManagerToJSON(requestParameters.manager),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagerFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateManagerRequestOptionsRaw(requestParameters: UpdateManagerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateManager.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/managers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ManagerToJSON(requestParameters.manager),
        };
        return responseConfig
    }

    /**
     * update manager (Roles: manager)
     */
    async updateManager(requestParameters: UpdateManagerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manager> {
        const response = await this.updateManagerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a tenant (Roles: manager)
     */
    async updateTenantRaw(requestParameters: UpdateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tenant>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTenant.');
        }

        if (requestParameters.tenant === null || requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('Tenant','Required parameter requestParameters.tenant was null or undefined when calling updateTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantToJSON(requestParameters.tenant),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateTenantRequestOptionsRaw(requestParameters: UpdateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTenant.');
        }

        if (requestParameters.tenant === null || requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('Tenant','Required parameter requestParameters.tenant was null or undefined when calling updateTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: TenantToJSON(requestParameters.tenant),
        };
        return responseConfig
    }

    /**
     * Update a tenant (Roles: manager)
     */
    async updateTenant(requestParameters: UpdateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tenant> {
        const response = await this.updateTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace a tenant\'s AI main-context sections (Roles: manager)
     */
    async updateTenantMainContextRaw(requestParameters: UpdateTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantMainContext>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTenantMainContext.');
        }

        if (requestParameters.tenantMainContext === null || requestParameters.tenantMainContext === undefined) {
            throw new runtime.RequiredError('TenantMainContext','Required parameter requestParameters.tenantMainContext was null or undefined when calling updateTenantMainContext.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/tenants/{id}/main-context`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantMainContextToJSON(requestParameters.tenantMainContext),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantMainContextFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateTenantMainContextRequestOptionsRaw(requestParameters: UpdateTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTenantMainContext.');
        }

        if (requestParameters.tenantMainContext === null || requestParameters.tenantMainContext === undefined) {
            throw new runtime.RequiredError('TenantMainContext','Required parameter requestParameters.tenantMainContext was null or undefined when calling updateTenantMainContext.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/tenants/{id}/main-context`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: TenantMainContextToJSON(requestParameters.tenantMainContext),
        };
        return responseConfig
    }

    /**
     * Replace a tenant\'s AI main-context sections (Roles: manager)
     */
    async updateTenantMainContext(requestParameters: UpdateTenantMainContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantMainContext> {
        const response = await this.updateTenantMainContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const EnterTenantRoleEnum = {
    Physician: 'physician',
    Admin: 'admin'
} as const;
export type EnterTenantRoleEnum = typeof EnterTenantRoleEnum[keyof typeof EnterTenantRoleEnum];
